import React from "react";
import northShoreReadersChoiceBadge from "../../assets/img/north-shore-readers-choice-badge-2026.jpeg";
import consumerChoiceAward2024Badge from "../../assets/img/consumer-choice-award-badge-2026.jpg";
import greatPlaceToWorkBadge from "../../assets/img/great-place-to-work-badge-2026.jpg";
import canadianCertifiedBadge from "../../assets/img/canadian-landscape-and-nursery-association.jpeg";
import homeStarsBadge from "../../assets/img/homestars-trusted-professional-badge.jpg";
import bcCertifiedBadge from "../../assets/img/bc-landscape-and-nursery-association.jpeg";
import redSealCertification from "../../assets/img/red-seal-certification-badge.jpg";
import contractorCheckBadge from '../../assets/img/contractorcheck-accredited-badge.jpg'
import './style.css';

export default function Awards(){
    return(
        <>
    <section id="partners" className="partners">
          <div className="container-partners">
            <div className="row d-flex align-items-center justify-content-center">
              <div className="partners-section-heading">
                <h2 className="section-header" data-aos="fade-down">
                  Awards and Affiliations
                </h2>
              </div>
              <div className="col-1-5" data-aos="zoom-in">
                <img loading="lazy"
                  src={northShoreReadersChoiceBadge}
                  className="img-fluid partners-img"
                  alt="North Shore News Readers' Choice Winner 2023"
                  style={{ width: "50%" }}
                />
              </div>
              <div className="col-1-5" data-aos="zoom-in">
                <img loading="lazy"
                  src={consumerChoiceAward2024Badge}
                  className="img-fluid partners-img"
                  alt="Consumer Choice Award Winner 2024 Vancouver"
                  style={{ width: "45%" }}
                />
              </div>
              <div className="col-1-5" data-aos="zoom-in">
                <img loading="lazy"
                  src={greatPlaceToWorkBadge}
                  className="img-fluid partners-img partner3"
                  alt="Great Place to Work Certified 2024-2025"
                  style={{ width: "35%" }}
                />
              </div>
              <div className="col-1-5" data-aos="zoom-in">
                <img loading="lazy"
                  src={bcCertifiedBadge}
                  className="img-fluid partners-img partner4"
                  alt="Bee Safe Initiative - Be Pesticide Free Logo"
                  style={{ width: "70%" }}
                />
              </div>
              <div className="col-1-5" data-aos="zoom-in">
                <img loading="lazy"
                  src={contractorCheckBadge}
                  className="img-fluid partners-img partner5"
                  alt="ContractorCheck Accredited Member Badge"
                  style={{ width: "70%" }}
                />
              </div>
              <div className="col-1-5" data-aos="zoom-in">
                <img loading="lazy"
                  src={homeStarsBadge}
                  className="img-fluid partners-img partner6"
                  alt="HomeStars Trusted Professional Logo"
                  style={{ width: "90%" }}
                />
              </div>
              <div className="col-1-5" data-aos="zoom-in">
                <img loading="lazy"
                  src={canadianCertifiedBadge}
                  className="img-fluid partners-img partner7"
                  alt="ICPI Certified Concrete Paver Installer"
                  style={{ width: "55%" }}
                />
              </div>
              <div className="col-1-5" data-aos="zoom-in">
                <img loading="lazy"
                  src={redSealCertification}
                  className="img-fluid partners-img partner8"
                  alt="Interprovincial Standard Red Seal Certification"
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </div>
        </section>
        </>
    );}